import template from './sw-cms-block-image-text.html.twig';
import './sw-cms-block-image-text.scss';

/**
 * @private
 * @package buyers-experience
 */
export default {
    template,
};
